import { AxiosResponse } from 'axios';
import { createApiClient } from './apiBase';
import { LoginRequest, LoginResponse, User } from '../types';

const api = createApiClient();

// ===== Authentication API =====
// Shared across all surfaces — admin, portal, and shop users authenticate the same way.

export async function login(credentials: LoginRequest): Promise<AxiosResponse<LoginResponse>> {
  return api.post('/auth/login', credentials);
}

export async function signup(data: {
  company_name: string;
  admin_first_name: string;
  admin_last_name: string;
  admin_email: string;
  admin_password: string;
}): Promise<AxiosResponse<{ message: string; company_id: number; user_id: number }>> {
  return api.post('/auth/register', data);
}

export async function getCurrentUser(): Promise<AxiosResponse<User>> {
  return api.get('/auth/me');
}

export async function verifyEmail(token: string): Promise<AxiosResponse<{
  message: string;
  success: boolean;
  user_email?: string;
}>> {
  return api.post('/auth/verify-email', null, { params: { token } });
}

export async function resendVerificationEmail(email: string): Promise<AxiosResponse<{
  message: string;
  success: boolean;
}>> {
  return api.post('/auth/resend-verification', { email });
}

export async function forgotPassword(email: string): Promise<AxiosResponse<{ message: string }>> {
  return api.post('/auth/forgot-password', { email });
}

export async function resetPassword(data: { token: string; new_password: string }): Promise<AxiosResponse<{ message: string }>> {
  return api.post('/auth/reset-password', data);
}

export async function getCompanyUsers(): Promise<AxiosResponse<{ users: User[]; total: number }>> {
  return api.get('/auth/users');
}

export async function loginWithGoogle(credential: string): Promise<AxiosResponse<LoginResponse>> {
  return api.post('/auth/google', { credential });
}

export async function logout(): Promise<void> {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
}
